module.exports = {
  // SERVER_URL: 'http://localhost:3005/api',
  // IMAGE_URL: 'http://localhost:3005',
  SERVER_URL: `https://${process.env.REACT_APP_HOST}/api`,
  IMAGE_URL: `https://${process.env.REACT_APP_HOST}`,
  PUBLIC_IMAGE_URL: `https://autobevy.sgp1.digitaloceanspaces.com/`,
};
